var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(this.currentComponent,{tag:"component"}),_vm._v(" "),_c('div',{staticClass:"ctaWrapper"},[_c('ChoiceConfirm',{attrs:{"disabled":this.$store.getters.onboardingNextDisabled(this.step)},on:{"click":_vm.increment}},[_vm._v("\n      NEXT\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1672efb8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/onboarding/OnboardingView.vue
// module id = 594
// module chunks = 1